// @flow

import { MOUNT_POINT } from 'esm-web-pro/redux/documentTitle';
import type { State } from './reducer';

const getDocumentTitle = (state: State): string => state[MOUNT_POINT];

export default getDocumentTitle;
